export default {
    title: "User overview",
    backToLink: {
        text: "Back to",
        section: "roles and users"
    },
    fullName: "Full name",
    email: "Email",
    roles: "Roles",
    button: {
        save: "Save",
        back: "Back",
        edit: "Edit"
    },

    showUser: {
        title: "Roles and users",
        tabs: {
            roles: "Roles",
            users: "Users"
        },
        addUser: "Add User",
        search: "Search email",
        deleteUser: "Delete",
        table: {
            username: "Username",
            email: "Email",
            roles: "Roles"
        }
    }
}
